module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "untitled-1"
    }
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override9"
  }, [_c('br', {
    staticClass: "calibre1"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "chapter-sub"
  }, [_vm._v("Cast of Primary Characters")]), _vm._v(" "), _c('p', {
    staticClass: "chapter-sub"
  }, [_vm._v("The port side of the Atlantic ")]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override3"
  }, [_c('span', {
    staticClass: "no-style-override16"
  }, [_vm._v("Max Blake:")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v(" Private detective; retired college professor and former investigative reporter")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override3"
  }, [_c('span', {
    staticClass: "no-style-override16"
  }, [_vm._v("Caeli Brown:")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v(" Max’s fiancée/business partner and a former newspaper reporter ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override3"
  }, [_c('span', {
    staticClass: "no-style-override16"
  }, [_vm._v("Bill Kohlmeyer:")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v(" Chief of police of Oregon’s capital city")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override3"
  }, [_c('span', {
    staticClass: "no-style-override16"
  }, [_vm._v("Fredo Fierro: ")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("The new ")]), _c('span', {
    staticClass: "no-style-override8"
  }, [_vm._v("capo di tutti capi")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("; Max’s and Caeli’s friend and sole client")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override3"
  }, [_c('span', {
    staticClass: "no-style-override16"
  }, [_vm._v("Elmore and Leonard: ")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Fierro Enterprises (USA) employees/bodyguards  ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override3"
  }, [_c('span', {
    staticClass: "no-style-override16"
  }, [_vm._v("Michael J. Parker:")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v(" Max’s and Caeil’s friend and attorney")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override3"
  }, [_c('span', {
    staticClass: "no-style-override16"
  }, [_vm._v("Dr. Floyd Strand:")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v(" Max’s friend, golf buddy, and medical adviser")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override3"
  }, [_c('span', {
    staticClass: "no-style-override16"
  }, [_vm._v("Mitts: ")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Caeli’s 26-pound Maine Coon cat")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override3"
  }, [_c('span', {
    staticClass: "no-style-override16"
  }, [_vm._v("Koko:")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v(" Caeli’s midnight-black rescue cat")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter-sub"
  }, [_vm._v("The starboard side of the Atlantic  ")]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override3"
  }, [_c('span', {
    staticClass: "no-style-override16"
  }, [_vm._v("The Rev. Sean “Jack” O’Lennox:")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v(" Caeli’s uncle, the former Archbishop of Armagh")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override3"
  }, [_c('span', {
    staticClass: "no-style-override16"
  }, [_vm._v("Roberto Fierro: ")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("The late Don Vincenzo’s lookalike brother; Fredo’s uncle")])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal-310-0-override3"
  }, [_c('span', {
    staticClass: "no-style-override16"
  }, [_vm._v("Guglielmo Morandini:")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v(" Don Roberto’s gardener and occasional chauffer ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override3"
  }, [_c('span', {
    staticClass: "no-style-override16"
  }, [_vm._v("Monsignor Luca LaGuardia: ")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Papal wheeler-dealer  ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override3"
  }, [_c('span', {
    staticClass: "no-style-override16"
  }, [_vm._v("Father Antonio Rizzo:")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v(" Resident Vatican good guy")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override3"
  }, [_c('span', {
    staticClass: "no-style-override16"
  }, [_vm._v("Father Pietro Angelus:")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v(" Resident Vatican bad guy")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override3"
  }, [_c('span', {
    staticClass: "no-style-override16"
  }, [_vm._v("Penn and Teller:")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v(" Fierro Enterprises (International) employees")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override3"
  }, [_c('span', {
    staticClass: "no-style-override16"
  }, [_vm._v("Bruno Coretti:")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v(" the Mayor of Nepi, Italy")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override3"
  }, [_c('span', {
    staticClass: "no-style-override16"
  }, [_vm._v("Ruth Coretti:")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v(" Kidnap victim and the mayor’s wife")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override3"
  }, [_c('span', {
    staticClass: "no-style-override16"
  }, [_vm._v("Chiara Coretti:")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v(" Bruno’s and Ruth’s daughter")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "calibre_pb_16"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-659cc54a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/CastOfCharacters.vue
// module id = 75
// module chunks = 0